import { render, staticRenderFns } from "./Shops.vue?vue&type=template&id=38a21582&scoped=true"
import script from "./Shops.vue?vue&type=script&lang=ts"
export * from "./Shops.vue?vue&type=script&lang=ts"
import style0 from "./Shops.vue?vue&type=style&index=0&id=38a21582&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a21582",
  null
  
)

export default component.exports